import type { TextProps } from '@mantine/core';
import { Text } from '@mantine/core';
import { forwardRef, type HTMLAttributes, type PropsWithChildren } from 'react';

type Props = PropsWithChildren<
	TextProps &
		HTMLAttributes<HTMLParagraphElement> & {
			bold?: boolean;
		}
>;

export const Footnote = forwardRef<HTMLParagraphElement, Props>(
	({ children, bold, ...props }, ref) => (
		<Text
			{...props}
			ref={ref}
			style={theme => ({
				fontFamily: theme.other.fonts.footnote.fontFamily,
				fontSize: theme.other.fonts.footnote.fontSize,
				fontWeight: bold
					? theme.other.fonts.footnote.fontWeightBold
					: theme.other.fonts.footnote.fontWeightRegular,
				fontStyle: theme.other.fonts.footnote.fontStyle,
				lineHeight: theme.other.fonts.footnote.lineHeight,
				letterSpacing: theme.other.fonts.footnote.letterSpacing,
			})}
		>
			{children}
		</Text>
	),
);
Footnote.displayName = 'Footnote';
